module.exports = __webpack_public_path__ + "images/how-it-works-arrow-blue.png";